module.exports = __webpack_public_path__ + "images/prizeEnablementIcon-470bfa3286658f7e3dfc6cbebae6076b.svg";